import { render } from "./StockAlertReport.vue?vue&type=template&id=56b8d2d4&ts=true"
import script from "./StockAlertReport.vue?vue&type=script&lang=ts"
export * from "./StockAlertReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__